<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input style="width:100%" v-model:value="form.id"/>
                </a-form-item>
                <a-form-item label="guarantyType" name="guarantyType">
                    <a-input style="width:100%" v-model:value="form.guarantyType" />
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="24">
                    <a-form-item label="产品主图11" name="img">
                        <img-upload v-model:value="form.img"  @delete="handleCustomDelete()"/>
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="8">
                    <a-form-item label="类型" name="type">
                        <DictSelect
                            v-model:value="form.type"
                            :dict-name="financeDict.LOANTYPE"
                            placeholder="请选择类型"
                        />
                    </a-form-item>
                </a-col> -->
                <a-col :span="8">
                    <a-form-item label="产品名称" name="productName">
                        <a-input style="width:100%" v-model:value="form.productName" placeholder="请输入产品名称" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="最高贷款金额(万元)" name="maxLoanLines">
                        <a-input style="width:100%" v-model:value="form.maxLoanLines" placeholder="请输入最高贷款金额(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="贷款利率(%)" name="rate">
                        <a-input style="width:100%" v-model:value="form.rate" placeholder="请输入贷款利率(%)" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="联系方式" name="contact">
                        <a-input style="width:100%" v-model:value="form.contact" placeholder="请输入联系方式" />
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="8">
                    <a-form-item label="所属银行" name="guarantyType">
                        <a-select v-model:value="form.guarantyType"  placeholder="请选择" >
                            <a-select-option
            v-for="item in userList"
            :key="item.id"
            :value="item.id"
        >
            {{ item.name }}
        </a-select-option>
                        </a-select>

                    </a-form-item>
                </a-col> -->
                <a-col :span="8">
                    <a-form-item label="贷款期" name="loanDeadline">
                        <DictSelect
                            v-model:value="form.loanDeadline"
                            :dict-name="financeDict.LOANDEADLINE"
                            placeholder="请选择"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="还款方式" name="paymentType">
                        <DictSelect
                            v-model:value="form.paymentType"
                            :dict-name="financeDict.PAYMENTTYPE"
                            placeholder="请选择"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="产品详细介绍" name="details">
                        <a-textarea v-model:value="form.details" placeholder="请输入产品详细介绍" :rows="4" />
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>
    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {financeProduct} from "@/api/finance";
import {financeDict} from "@/config/variableConfig";
// import DictSelect from "@/components/other/DictSelect";
export default {
    name: "AddOrEditModal",
    // components: {DictSelect},

    mixins: [formMixin],
    data() {
        return {
            userId: null,
            financeDict,
            form: {
                id: null,
                img: null,
                companyCode: null,
                productId: null,
                mechanismId: null,
                maxLoanLines: null,
                rate: null,
                type: null,
                contact: null,
                productName: null,
                details: null,
                guarantyType: null,
                loanDeadline: null,
                paymentType: null,

            },
            rules: {
                    id: [],
                    companyCode: [],
                    img: [],
                    productId: [dataCheck.required({})],
                    mechanismId: [dataCheck.required({})],
                    maxLoanLines: [dataCheck.required({})],
                    rate: [dataCheck.required({})],
                    type: [dataCheck.required({})],
                    contact: [dataCheck.required({}),dataCheck.phone],
                    productName: [dataCheck.required({})],
                    // guarantyType: [dataCheck.required({})],
                    loanDeadline: [dataCheck.required({})],
                    paymentType: [dataCheck.required({})],
                    details: [dataCheck.required({})]
            },

            options: [],

        }
    },

    computed: {

            submitUrl() {
                if (this.form.id) {
                    return financeProduct.edit
                } else {

                    return financeProduct.add
                }
            },
            postMethod() {
                if (this.form.id) {
                    return 'put'
                } else {
                    return 'post'
                }
            }
        },
    mounted() {

    },
    created() {

    },
    methods: {
        handleCustomDelete(){
            console.log("11111111111");
            this.form.img = ''
        }
        // getUserList() {
        //         this.getAction({
        //             url: sys_admin.getListByRoleId,
        //             params: {
        //                roleId:'007',
        //                auditStatus:"1"
        //          }
        //         }).then(res => {
        //             this.userList = res
        //         })
        //     },
    },
}
</script>
<style scoped lang="less">
</style>
